module.exports = __webpack_public_path__ + "static/Gotham-BlackItalic-4d6e442f77d2add4787e9bb78d6171a5.woff2";